import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA, MatSlideToggleChange } from '@angular/material';
import { UserDto, UserAssignRoles } from '../../../../models/user.model';
import { RolesService } from '../../../../services/roles.service';
import { Role } from '../../../../roles/models/role.model';
import { UserService } from '../../../../services/user.service';

@Component({
  selector: 'app-user-assign-roles',
  templateUrl: './user-assign-roles.component.html',
  styleUrls: ['./user-assign-roles.component.css']
})
export class UserAssignRolesComponent implements OnInit {
  roles: Role[];
  constructor(
    private roleService: RolesService,
    private userService: UserService,
    public dialogRef: MatDialogRef<UserAssignRolesComponent>,
    @Inject(MAT_DIALOG_DATA) public data: UserAssignRoles) {}

    ngOnInit() {
      this.dialogRef.keydownEvents().subscribe(event => {
        if (event.key === 'Escape') {
            this.onCancel();
        }
    });

    this.dialogRef.backdropClick().subscribe(event => {
        this.onCancel();
    });
    this.loadRoles();
    this.userService.get(this.data.user.id).subscribe(user => {
      this.data.user = user;
      this.data.roles = user.roles;
    });
  }
  loadRoles() {
    this.roleService.GetAll().subscribe(roles => {
      this.roles = roles;
    });
  }
  onCancel() {
    this.dialogRef.close();
  }
  hasRole(role: string): boolean {
    if (!this.data.roles) {
      return false;
    }
    return this.data.roles.includes(role);
  }
  onToggleChange(toggle: MatSlideToggleChange, role: string) {
    if (!this.data.roles) {
      this.data.roles = [];
    }
    const index: number = this.data.roles.indexOf(role);
    if (toggle.checked) {
      if (index === -1) {
        this.data.roles.push(role);
      }
    } else {
      if (index !== -1) {
        this.data.roles.splice(index, 1);
      }
    }
  }
}
